import { FC, useState } from 'react';
import ModalDialog from '../components/modal/ModalDialog';
import LoadingSpinner from '../components/LoadingSpinner';
import { Trans, useTranslation } from 'react-i18next';
import { useFindUsersForImpersonation, useImpersonateUser } from '../../api/impersonation/useImpersonateUser';

type Props = {
    readonly show: boolean;
    readonly onClose: () => void;
};

const ImpersonationDialog: FC<Props> = ({ onClose, show }) => {
    const { t } = useTranslation();
    const [userName, setUserName] = useState('');

    const { data: users, isLoading: usersLoading } = useFindUsersForImpersonation({
        searchString: userName,
        enabled: show
    });

    const { mutate } = useImpersonateUser();

    return (
        <ModalDialog
            show={show}
            title={t('components.impersonation.title')}
            onCloseButtonClick={() => {
                onClose();
                setUserName('');
            }}
        >
            <p className="txt-normal" style={styles.textHint}>
                {t('components.impersonation.subtitle')}
                <br />
                <span className="cold-grey">
                    <Trans
                        i18nKey="components.impersonation.description"
                        components={{
                            br: <br />
                        }}
                    />
                </span>
            </p>
            <p className="txt-normal">
                <input
                    onChange={event => setUserName(event.target.value)}
                    value={userName}
                    placeholder={t('components.impersonation.searchPlaceholder')}
                    style={styles.searchInput}
                />
            </p>
            {usersLoading ? (
                <LoadingSpinner width={50} />
            ) : (
                <ul style={styles.userList}>
                    {users.map(({ id, username }) => (
                        <li key={id}>
                            <a onClick={() => mutate(id)}>
                                <i className="material-icons">face</i>&nbsp;
                                {username}
                            </a>
                        </li>
                    ))}
                </ul>
            )}
        </ModalDialog>
    );
};

const styles = {
    userList: {
        maxHeight: '400px',
        overflow: 'auto',
        fontSize: '14px',
        lineHeight: '24px'
    },
    searchInput: {
        width: '80%',
        borderBottom: '1px solid lightgray',
        marginRight: '10px'
    },
    textHint: {
        lineHeight: '20px'
    }
};
export default ImpersonationDialog;
